export default "__VITE_ASSET__8dbjCmmB__"